import PropTypes from "prop-types";
import { Marker } from "react-map-gl";
import styles from "components/stay/LocationMapMarker.module.scss";

export default function LocationMapMarker({ latitude, longitude }) {
  return (
    <Marker
      latitude={latitude}
      longitude={longitude}
      offsetLeft={-(styles.sizeMarker / 2)}
      offsetTop={-(styles.sizeMarker / 2)}
    >
      <div className={styles.component}>
        <div className={styles.point} />
      </div>
    </Marker>
  );
}

LocationMapMarker.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
};
